import { render, staticRenderFns } from "./DisputesHistoryComponent.vue?vue&type=template&id=09dc56c0&scoped=true"
import script from "./DisputesHistoryComponent.vue?vue&type=script&lang=js"
export * from "./DisputesHistoryComponent.vue?vue&type=script&lang=js"
import style0 from "./DisputesHistoryComponent.vue?vue&type=style&index=0&id=09dc56c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dc56c0",
  null
  
)

export default component.exports